import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { Attachment } from "../../xapp/Attachment";
import { ChatState } from "../ChatState";
import { ChatDispatch } from "./types";

export default function sendFile(file: File): ChatServerAsyncActionType {
    return chatServer => (dispatch: ChatDispatch, getState: () => ChatState) => {
        const state = getState();
        // Don't allow visitor to send file if offline
        if (state.accountStatus === "offline" && !state.isChatting) return;


        // Generate attachment object for local echo
        const attachment: Attachment = {
            mimeType: file.type,
            name: file.name,
            size: file.size,
            url: window.URL.createObjectURL(file)
        }

        chatServer.sendFile(file, (err?: Error) => {
            if (err) {
                log("Error sending file", err);
                return;
            }
        });

        dispatch({
            type: "synthetic",
            detail: {
                type: "visitor.send.file",
                attachment,
                user: {
                    nick: "",
                },
                attributes: { currentUrl: window.location.href },
                timestamp: +new Date()
            }
        });

    }

}